import { render, staticRenderFns } from "./modal-b80a8704.vue?vue&type=template&id=649cb40e&scoped=true&"
import script from "./modal-b80a8704.vue?vue&type=script&lang=js&"
export * from "./modal-b80a8704.vue?vue&type=script&lang=js&"
import style0 from "./modal-b80a8704.vue?vue&type=style&index=0&id=649cb40e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "649cb40e",
  null
  
)

export default component.exports